import React from 'react';
import { Search } from 'lucide-react';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface SearchFormProps {
  searchAccount: string;
  setSearchAccount: (value: string) => void;
  searchTeam: string;
  setSearchTeam: (value: string) => void;
  searchProject: string;
  setSearchProject: (value: string) => void;
  onSearch: () => void;
}

export function SearchForm({
  searchAccount,
  setSearchAccount,
  searchTeam,
  setSearchTeam,
  searchProject,
  setSearchProject,
  onSearch,
}: SearchFormProps) {
  return (
    <div className="space-y-2">
      <div className="relative">
        <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
        <Input
          placeholder="Account number..."
          value={searchAccount}
          onChange={(e) => setSearchAccount(e.target.value)}
          className="pl-9"
        />
      </div>
      <Input
        placeholder="Team..."
        value={searchTeam}
        onChange={(e) => setSearchTeam(e.target.value)}
      />
      <Input
        placeholder="Project..."
        value={searchProject}
        onChange={(e) => setSearchProject(e.target.value)}
      />
      <Button 
        onClick={onSearch}
        className="w-full bg-[#ff6d00] hover:bg-[#ff6d00]/90 text-white font-semibold"
        size="lg"
      >
        Search Categories
      </Button>
    </div>
  );
}